/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import {useEffect} from 'react'


export default function Body() {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <div className="flex justify-center">
            <div className="ml-20 vt-legal" dangerouslySetInnerHTML={{
                __html: "<p><strong>Privacy Policy for VirtualTipz</strong></p>\n" +
                    "<p><br></p>\n" +
                    "<p>VirtualTipz one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by VirtualTipz and how we use it.</p>\n" +
                    "<p><br></p>\n" +
                    "<p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>\n" +
                    "<p><br></p>\n" +
                    "<p>This privacy policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect on VirtualTipz. This policy is not applicable to any information collected offline or via channels other than this website.</p>\n" +
                    "<br><p><b>Consent</b></p>\n" +
                    "<p><br></p>\n" +
                    "<p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</span></p>\n" +
                    "<p><br></p>\n" +
                    "<p><strong>Information we collect</strong></p>\n" +
                    "<p><br></p>\n" +
                    "<p>The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.</p>\n" +
                    "<p><br></p>\n" +
                    "<p>If you contact us directly, we may receive additional information about you such as your name, email address, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.</p>\n" +
                    "<p><br></p>\n" +
                    "<p>When you register for an Account, we may ask for your contact information, including items such as name and email address.</p>\n" +
                    "<p><br></p>\n" +
                    "<p><strong>How we use your information</strong></p>\n" +
                    "<p><br></p>\n" +
                    "<p>We use the information we collect in various ways, including to:</p>\n" +
                    "<p><br></p>\n" +
                    "<ul>\n" +
                    "    <li>Provide, operate, and maintain our website</li>\n" +
                    "    <li>Improve, personalize, and expand our website</li>\n" +
                    "    <li>Communicate with you to provide you with updates and other information relating to the website</li>\n" +
                    "    <li>Send you emails</li>\n" +
                    "    <li><b>We do not and will never sell your information to third parties</b></li>\n" +
                    "</ul>\n" +
                    "<p><br></p>\n" +
                    "<p><strong>CCPA Privacy Policy (Do Not Sell My Personal Information)</strong></p>\n" +
                    "<p><br></p>\n" +
                    "<p>Under the CCPA, among other rights, California consumers have the right to:</p>\n" +
                    "<p><br></p>\n" +
                    "<ul>\n" +
                    "    <li>Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.</li>\n" +
                    "    <li>Request that a business delete any personal data about the consumer that a business has collected.</li>\n" +
                    "    <li>Request that a business that sells a consumer's personal data, not sell the consumer's personal data.</li>\n" +
                    "</ul>\n" +
                    "<p><br></p>\n" +
                    "<p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>\n" +
                    "<p><br></p>\n" +
                    "<p><strong>GDPR Privacy Policy (Data Protection Rights)</strong></p>\n" +
                    "<p><br></p>\n" +
                    "<p>We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>\n" +
                    "<p><br></p>\n" +
                    "<ul>\n" +
                    "    <li>The right to access &ndash; You have the right to request copies of your personal data. We may charge you a small fee for this service.</li>\n" +
                    "    <li>The right to rectification &ndash; You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</li>\n" +
                    "    <li>The right to erasure &ndash; You have the right to request that we erase your personal data, under certain conditions.</li>\n" +
                    "    <li>The right to restrict processing &ndash; You have the right to request that we restrict the processing of your personal data, under certain conditions.</li>\n" +
                    "    <li>The right to object to processing &ndash; You have the right to object to our processing of your personal data, under certain conditions.</li>\n" +
                    "    <li>The right to data portability &ndash; You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</li>\n" +
                    "</ul>\n" +
                    "<p><br></p>\n" +
                    "<p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>\n" +
                    "<p><br></p>\n" +
                    "<p><strong>Children's Information</strong></p>\n" +
                    "<p><br></p>\n" +
                    "<p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>\n" +
                    "<p><br></p>\n" +
                    "<p>VirtualTipz does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>\n" +
                    "<p><br></p>\n" +
                    "<p><strong>Questions</strong></p>\n" +
                    "<p><br></p>\n" +
                    "<p>If you have any questions about this Privacy Policy, please contact us.</p> " +
                    "<p>Push Enterprise Technologies LLC\n<br>" +
                    " 7319 MATTHEWS MINT HILL RD, SUITE I #122\n<br>" +
                    "Mint Hill, NC 28227\n<br>" +
                    "United States\n<br>" +
                    "Phone: (+1)9197103867\n<br>" +
                    "pushenterprisetechnologies@gmail.com</p><br>" +
                    ""
            }}/>
        </div>
    )
}
